import React, { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Shared UI Library Components
import { BreadcrumbElement } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './counsellor-header.scss';

// Models
import { ICounsellor } from '../../../../interfaces/counsellors.interfaces';

type TLayoutHeaderProps = {
  counsellor: ICounsellor;
};

export const CounsellorHeader: FC<TLayoutHeaderProps> = (
  { counsellor }: TLayoutHeaderProps
): JSX.Element => {

  const location = useLocation();
  const navigate = useNavigate();

  const isRatesPage = location.pathname.split('/').includes('rates');

  const navigateTo = (url: string): void => {
    navigate(url);
  }

  return (
    <div className="counsellor-header">
      <BreadcrumbElement threeItems={ [
        {
          title: 'Consultants',
          onClick: () => navigateTo(`/counsellors`)
        },
        {
          className: 'disabled-crumb',
          title: `${ counsellor.first_name } ${ counsellor.last_name }`,
          onClick: () => navigateTo(`/counsellors/${ counsellor.id }`)
        },
        {
          title: isRatesPage ? 'Rates' : 'Personal Data',
        },
      ] }/>
    </div>
  )
};
